import ExamDocApi from 'api/ExamDocApi';
import ReactTable from 'components/ReactTable/ReactTable';
import ApiCaller from 'lib/ApiCaller';
import MYDocument, { MYDocumentStatus } from 'lib/common/models/myDocument';
import MYDocumentStatusLog from 'lib/common/models/myDocumentStatusLog';
import MYDocumentStatusLogCollection from 'lib/common/models/myDocumentStatusLogCollection';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { DEFAULT_TIMEZONE_FORMAT, formatDateTime, sortDateTable } from 'shared/utils/dateTime';
import { AppState } from 'store/store';

interface ExamDocumentStatusesProps {
    document: MYDocument;
}

const ExamDocumentStatuses: React.FC<ExamDocumentStatusesProps> = ({ document }) => {
    const loggedUser = useSelector((state: AppState) => state.session.userInfo);
    const [statuses, setStatuses] = React.useState<MYDocumentStatusLogCollection>(
      new MYDocumentStatusLogCollection([]),
    );
  
    useEffect(() => {
      if (document.id) {
        const docApi = new ExamDocApi(new ApiCaller());
        docApi.loadAllStatusLogs(document.id, loggedUser.token).then((statuses: MYDocumentStatusLogCollection) => {
          setStatuses(statuses);
        });
      }
    }, []);
  
    const columns = [
      {
        Header: 'TIMESTAMP',
        accessor: (d: MYDocumentStatusLog) =>
          formatDateTime(d.timestamp, DEFAULT_TIMEZONE_FORMAT),
        sortable: true,
        sortType: (a: MYDocumentStatusLog, b: MYDocumentStatusLog) => sortDateTable(a, b, 'timestamp'),
      },
      {
        Header: 'STATUS',
        accessor: (d: MYDocumentStatusLog) => (d.status ? MYDocumentStatus[d.status as keyof typeof MYDocumentStatus] : ''),
        sortable: true,
      },
      {
        Header: 'COMMENT',
        accessor: (d: MYDocumentStatusLog) => (d.comment ? d.comment : ''),
        sortable: true,
      },
      {
        Header: 'EDITOR',
        accessor: (d: MYDocumentStatusLog) => (typeof d.createdBy === 'object' ? d.createdBy.name : '-'),
        sortable: true,
      },
    ];
    return (
        <div className="content">
        <Card>
          <CardHeader>
            <h4 className="card-title">Document Trail</h4>
          </CardHeader>
          <CardBody>
            <ReactTable data={statuses.data} columns={columns} />
          </CardBody>
        </Card>
      </div>
    );
};

export default ExamDocumentStatuses;